import * as React from 'react';
import clsx from 'clsx';
import { useText } from './useText';
function Text({
  tagName = 'span',
  component,
  children,
  refCallback,
  innerRef,
  className,
  ...extraProps
}) {
  const [textClasses, textExtra] = useText(extraProps);
  if (component && /*#__PURE__*/React.isValidElement(component)) {
    return /*#__PURE__*/React.cloneElement(component, {
      ref: refCallback,
      className: clsx(textClasses, component.props.className, className),
      ...textExtra
    });
  }
  return /*#__PURE__*/React.createElement(tagName, {
    ref: innerRef || refCallback,
    className: clsx(textClasses, className),
    ...textExtra
  }, children);
}
export default Text;